import { lazy } from "react";
import { FeatureFlagRoute } from "../../_features/featureFlags/routing/FeatureFlagRoute";
import PermissionRoute from "./PermissionRoute";
import { ROUTE_PERMISSIONS } from "./routePermissions";

const SelfServeUsers = lazy(() => import("../../_features/selfServeUsers/pages/SelfServeUsersPage"));
const SelfServeDetails = lazy(() => import("../../_features/selfServeUsers/pages/SelfServeUserDetails"));

export const selfServeRoutes = [
    {
        path: "/selfserveusers", element:
            <FeatureFlagRoute feature="selfServeUsers">
                <PermissionRoute permission={ROUTE_PERMISSIONS.selfServeUsers.view} moduleName="Self-serve users"><SelfServeUsers /></PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/selfserveusers/:id", element:
            <FeatureFlagRoute feature="selfServeUsers">
                <PermissionRoute permission={ROUTE_PERMISSIONS.selfServeUsers.view} moduleName="Self-serve users"><SelfServeDetails /></PermissionRoute>
            </FeatureFlagRoute>
    }
];
